export const LANGS = [
  { code: "sk", label: "SK" },
  { code: "en", label: "EN" },
  { code: "de", label: "DE" },
  { code: "pl", label: "PL" },
  { code: "fr", label: "FR" },
];

export const translations = {
  sk: {
    nav: {
      services: "Služby",
      about: "O nás",
      standard: "Sa.Eko Štandard",
      certification: "Certifikácia",
      contact: "Kontakt",
      cta: "Získať certifikát",
      login: "Prihlásiť / Registrovať",
    },
    hero: {
      badge: "Značka skutočných profesionálov",
      title: "SauberEko",
      subtitle: "Kde sa odbornosť stáva štandardom.",
      paragraph:
        "SauberEko® nie je len o technických štandardoch. Je to záväzok k profesionalite, etike a najvyššej kvalite v akomkoľvek odvetví. Naším certifikátom potvrdzujeme, že jeho držiteľ patrí k elite vo svojom odbore.",
      ctaPrimary: "Rozpoznajte profesionála, kým je ešte čas",
      heroQuote: "„Dobrým človekom ťa nenaučíme byť — ale profesionálom áno.\nA každý pravý profesionál je aj dobrý človek.“",
      heroQuoteAuthor: "zakladateľ značky",
      ctaSecondary: "Spoznať štandard",
      scroll: "Objavte viac",
    },
    values: {
      overline: "Naše piliere",
      title: "Tri princípy, jedna prestížna značka",
      items: [
        { title: "Profesionalita", text: "Roky preukázanej odbornosti potvrdené nezávislým posúdením." },
        { title: "Etika", text: "Záväzok k čestnosti, transparentnosti a zodpovednosti." },
        { title: "Najvyššia kvalita", text: "Štandard, ktorý rešpektujú investori naprieč Európou." },
      ],
    },
    certification: {
      overline: "Certifikácia",
      title: "Pečať dôvery pod európskou ochrannou známkou",
      text:
        "Odborníci a spoločnosti certifikované nami zaručujú profesionalitu a roky odbornosti pod prestížnou európskou ochrannou známkou SauberEko®.",
      bullets: [
        "Nezávislé a objektívne posúdenie",
        "Európske uznanie a dôveryhodnosť",
        "Doživotná hodnota vašej značky",
      ],
    },
    standard: {
      overline: "Sa.Eko Štandard",
      title: "Jedinečný prístup k certifikácii",
      text:
        "Naša certifikácia je založená na individuálnom posúdení pomocou našich interných metód a je prispôsobená vašim potrebám na dosiahnutie profesionálnej excelentnosti.",
      steps: [
        { no: "01", title: "Posúdenie", text: "Dôkladná analýza vašej odbornosti a skúseností." },
        { no: "02", title: "Metodika", text: "Hodnotenie podľa interného štandardu Sa.Eko." },
        { no: "03", title: "Certifikát", text: "Udelenie prestížnej európskej značky SauberEko®." },
      ],
    },
    benefits: {
      overline: "Výhody",
      title: "Znižujeme náklady a zvyšujeme kvalitu.",
      text:
        "Spoluprácou so značkou profesionality a odbornosti SauberEko získate certifikát, ktorý potvrdzuje vašu profesionalitu a získava rešpekt a uznanie medzi významnými európskymi investormi. Tento certifikát vám zaručuje vyššiu dôveryhodnosť medzi subdodávateľmi a poskytuje vám konkurenčnú výhodu.",
      stats: [
        { value: "100%", label: "Individuálne posúdenie" },
        { value: "EÚ", label: "Európske uznanie" },
        { value: "Elita", label: "Vo vašom odbore" },
      ],
    },
    contact: {
      overline: "Kontakt",
      title: "Začnite svoju cestu k excelentnosti",
      text: "Napíšte nám a my vám pomôžeme získať prestížny certifikát SauberEko®.",
      name: "Meno a priezvisko",
      email: "E-mail",
      company: "Spoločnosť (nepovinné)",
      message: "Vaša správa",
      submit: "Odoslať správu",
      sending: "Odosielam...",
      success: "Ďakujeme! Vaša správa bola odoslaná.",
      error: "Niečo sa pokazilo. Skúste to znova.",
      consent: "Súhlasím so spracovaním osobných údajov",
      consentLink: "Zásady ochrany osobných údajov",
      consentRequired: "Pre odoslanie je potrebný súhlas so spracovaním osobných údajov.",
      phone: "Zavolajte nám",
      mail: "Napíšte nám",
      visit: "Nájdite nás",
    },
    footer: {
      tagline: "Značka skutočných profesionálov.",
      rights: "Všetky práva vyhradené.",
      privacy: "Zásady ochrany osobných údajov",
    },
    pages: {
      common: { partnership: "Spýtať sa na spoluprácu", consultation: "Rezervovať konzultáciu", contactCta: "Kontaktujte nás" },
      services: {
        overline: "Služby",
        title: "Profesionálna značka",
        subtitle: "Naše hlavné ponúkané služby",
        items: [
          {
            title: "Certifikácia spoločností a jednotlivcov",
            text: "Sú vaše metodiky skutočne jedinečné? Je váš prístup profesionálny? Získajte konkurenčnú výhodu s certifikátom Sa.Eko. Preukážte svoju excelentnosť cez naše hodnotiace procesy a súlad s Kódexom Sa.Eko.",
          },
        ],
        whyTitle: "Prečo si vybrať práve nás?",
        why: [
          { title: "Každý je pre nás jedinečný", text: "My aj naši spolupracovníci striktne dodržiavame štandardy Sa.Eko, ktoré vám zaručujú kvalitu a profesionalitu vo všetkých aspektoch." },
          { title: "Vynikajúce služby", text: "Naše služby sú zárukou kvality a striktného dodržiavania Kódexu Sa.Eko, chráneného ochrannou známkou SauberEko. Kvalitu nesľubujeme — garantujeme ju." },
          { title: "Bezplatná konzultácia", text: "Neváhajte nás kontaktovať; spoločne určite nájdeme riešenie a dohodu o spolupráci. Garantujeme vám profesionálny prístup." },
        ],
      },
      about: {
        overline: "O nás",
        title: "Vitajte v SauberEko®",
        subtitle: "„Značka skutočných profesionálov.“",
        intro:
          "Preukázané znalosti a skúsenosti našej značky profesionality a odbornosti zaručujú certifikovaných profesionálov. Naša značka sa vyznačuje prísnymi internými štandardmi a neustálym zlepšovaním odbornej praxe, čím poskytuje absolútnu dôveryhodnosť a jedinečnosť v odbore.",
        missionTitle: "Naša misia: Budovanie ekosystému skutočných profesionálov",
        missionText:
          "V dnešnom rýchlom svete, kde sa dôraz často kladie na kvantitu a rýchlosť, sa stráca to najpodstatnejšie — pravá odbornosť a poctivá práca. Naša skupina vznikla ako odpoveď na trh presýtený subjektmi, ktoré uprednostňujú krátkodobý zisk pred udržateľnou kvalitou. S viac ako 20 rokmi skúseností v technicky náročných odvetviach sme sa zaviazali vytvoriť platformu, ktorá je synonymom profesionality v každom sektore.",
        values: [
          { title: "Absolútna odbornosť", text: "Preukázaná rokmi praxe a reálnymi výsledkami." },
          { title: "Čestnosť a transparentnosť", text: "Férový prístup je základom každej našej dohody." },
          { title: "Ľudskosť a pokora", text: "Rešpekt k remeslu, k partnerom a k zodpovednosti, ktorú nesieme." },
        ],
        brandTitle: "Značka definovaná výsledkami, nie cenou",
        brandText:
          "Často hovoríme, že našu značku si nemožno „len tak“ kúpiť. Neznamená to, že sme uzavretí spolupráci — práve naopak. Znamená to však, že akékoľvek spojenie s naším menom je podmienené splnením prísne definovaných kritérií. Naše meno a povesť sú výsledkom dvoch desaťročí tvrdej práce.",
        criteriaTitle: "Našu dôveru a spoluprácu si získate, keď preukážete:",
        criteria: [
          "Skutočnú profesionalitu vo svojom odbore.",
          "Etický prístup k podnikaniu a klientom.",
          "Jasnú víziu byť medzi elitou, ktorá nerobí kompromisy v kvalite ani pod tlakom.",
        ],
        guaranteesTitle: "Garancie a certifikácia",
        guarantees: [
          { title: "Garancie a certifikácia", text: "Značka profesionality a odbornosti SauberEko sa špecializuje na overovanie skúseností a úrovne odbornosti spoločností a jednotlivcov v danom odvetví." },
          { title: "Medzinárodné certifikácie", text: "Spolupracujeme s domácimi aj zahraničnými partnermi, aby sme zaručili najvyššiu kvalitu poskytovaných služieb." },
          { title: "Profesijné certifikácie", text: "Profesionáli SauberEko držia rôzne certifikáty a majú dlhoročné skúsenosti na najvyššej úrovni." },
          { title: "Inovatívne garancie", text: "Naša značka profesionality a odbornosti ponúka inovatívne garancie, ktoré vám dodajú istotu a pokoj vo vašich podnikateľských aktivitách." },
        ],
      },
      certification: {
        overline: "Certifikácia",
        title: "Vyniknite z davu a ukážte všetkým, že ste profesionál!",
        individualsTitle: "Certifikácia jednotlivcov — Sa.Eko.Prs-2026-0001",
        individualsText: "Poskytujeme certifikáciu, ktorá preukazuje vašu odbornosť a prax, zlepšuje procesy a zvyšuje dôveru zákazníkov.",
        companiesTitle: "Certifikácia spoločností a firiem — Sa.Eko.Fa-2026-0001",
        companiesText: "Certifikujeme spoločnosti podľa našich interných štandardov, čím zvyšujeme povedomie a jedinečnosť firmy. Firmám prinášame excelentnosť a exkluzivitu.",
        individualsProcTitle: "Postup pre jednotlivcov",
        individualSteps: [
          { title: "Analýza potrieb", text: "Identifikujeme a analyzujeme požiadavky a ciele." },
          { title: "Registrácia", text: "Vyplnenie kontaktného formulára." },
          { title: "Plánovanie skúšky", text: "Vytvoríme harmonogram odbornej skúšky." },
          { title: "Realizácia skúšky", text: "Vykonáme odbornú skúšku, overíme vašu prax a zaznamenáme výsledky." },
          { title: "Vydanie certifikátu", text: "Po úspešnom absolvovaní vydáme certifikát podľa úrovne: Začiatočník, Skúsený, Profesionál." },
        ],
        companiesProcTitle: "Postup pre spoločnosti",
        companySteps: [
          { title: "Registrácia a komunikácia", text: "Podrobne definujte svoje zameranie a ciele." },
          { title: "Plánovanie hodnotenia", text: "Určíme postup a pripravíme tím profesionálov podľa vášho zamerania." },
          { title: "Hodnotenie", text: "Náš nezávislý tím vykoná dôkladné a presné hodnotenie odbornosti." },
          { title: "Záverečná správa", text: "Pripravíme záverečnú správu o profesionalite a odbornosti." },
          { title: "Certifikácia a audit", text: "Vykonáme certifikáciu s ročným auditom. Získate jedinečný certifikát Sa.Eko.Fa-2026 a exkluzivitu." },
        ],
      },
      code: {
        overline: "Kódex Sa.Eko",
        title: "Kódex profesijnej integrity a kvality",
        intro:
          "V SauberEko veríme, že špičkové výsledky vznikajú spojením technickej presnosti so silnými morálnymi princípmi. Naše štandardy Sa.Eko definujú, ako pristupujeme k projektom, partnerom a vlastnej odbornosti.",
        pillarsTitle: "10 pilierov našej odbornosti a zodpovednosti",
        pillars: [
          { title: "Kultúra rešpektu a pokory", text: "Ľudskosť je základom SauberEko. Ku každému projektu, kolegovi a partnerovi pristupujeme s pokorou a vzájomným rešpektom." },
          { title: "Radikálna transparentnosť kompetencií", text: "Garantujeme investorom 100% pravdivosť ohľadom našich zručností a skúseností. Nenadhodnocujeme svoje kapacity." },
          { title: "Vzájomná podpora Sa.Eko", text: "Budujeme prostredie silnej synergie. Ochota spolupracovať a podporovať tím je základnou požiadavkou." },
          { title: "Rozvoj, inovácie a ochrana ekológie", text: "Odbornosť vnímame ako nepretržitý proces. Aktívne zavádzame nové technológie a sme šetrní k prírode — uprednostňujeme ekologické materiály a postupy, ktoré šetria vodu aj energie. Tým spĺňame aj prísne hygienické a bezpečnostné nároky potravinárskeho priemyslu, kde čistota a ochrana zdravia nepoznajú kompromis." },
          { title: "Aktívne partnerstvo pri plánovaní", text: "Nie sme len dodávateľ, sme partner. Aktívne sa zapájame do návrhu projektu od začiatku." },
          { title: "Transparentnosť technického vybavenia", text: "Poskytujeme presné informácie o našej technike v bezchybnom stave spĺňajúcej všetky požiadavky." },
          { title: "Absolútna technická disciplína", text: "Bezpečnosť je priorita. Striktne dodržiavame servisné intervaly a certifikačné termíny." },
          { title: "Osobná záruka za prevedenie", text: "Za prácu SauberEko ručíme svojou povesťou. Každá úloha je vykonaná zodpovedne, s plnou zárukou." },
          { title: "Okamžitá náprava a minimalizácia chýb", text: "Sme proaktívni. Akékoľvek nedostatky riešime okamžite, aby sme minimalizovali dopad na investora." },
          { title: "Integrita celého reťazca", text: "Štandardy Sa.Eko rozširujeme aj na našich dodávateľov. Garantujeme, že každý článok zdieľa naše hodnoty." },
        ],
        declarationTitle: "Vyhlásenie žiadateľa",
        declaration: "Svojím podpisom potvrdzujem, že som sa oboznámil s Kódexom profesijnej integrity a kvality. Beriem na vedomie, že jeho porušenie je dôvodom na odňatie certifikátu Sa.Eko.",
      },
    },
  },

  en: {
    nav: {
      services: "Services",
      about: "About Us",
      standard: "Sa.Eko Standard",
      certification: "Certification",
      contact: "Contact",
      cta: "Get Certified",
      login: "Sign in / Register",
    },
    hero: {
      badge: "The Brand of True Professionals",
      title: "SauberEko",
      subtitle: "Where expertise becomes the standard.",
      paragraph:
        "SauberEko® is not just about technical standards. It is a commitment to professionalism, ethics and top quality in any industry. With our certificate, we confirm that the holder belongs to the elite in their field.",
      ctaPrimary: "Recognize a professional while there is still time",
      heroQuote: "“We can't teach you to be a good person — but a professional, yes.\nAnd every true professional is also a good person.”",
      heroQuoteAuthor: "founder of the",
      ctaSecondary: "Discover the standard",
      scroll: "Discover more",
    },
    values: {
      overline: "Our pillars",
      title: "Three principles, one prestigious mark",
      items: [
        { title: "Professionalism", text: "Years of proven expertise confirmed by independent assessment." },
        { title: "Ethics", text: "A commitment to honesty, transparency and accountability." },
        { title: "Top Quality", text: "A standard respected by investors across Europe." },
      ],
    },
    certification: {
      overline: "Certification",
      title: "A seal of trust under the European trademark",
      text:
        "Experts and Companies certified by us guarantee professionalism and years of expertise under the prestigious European SauberEko® trademark.",
      bullets: [
        "Independent and objective assessment",
        "European recognition and credibility",
        "Lasting value for your brand",
      ],
    },
    standard: {
      overline: "Sa.Eko Standard",
      title: "Unique approach to certification",
      text:
        "Our certification is based on individual assessment using our internal methods and tailored to your needs to achieve professional excellence.",
      steps: [
        { no: "01", title: "Assessment", text: "A thorough analysis of your expertise and experience." },
        { no: "02", title: "Methodology", text: "Evaluation against the internal Sa.Eko standard." },
        { no: "03", title: "Certificate", text: "Award of the prestigious European SauberEko® mark." },
      ],
    },
    benefits: {
      overline: "Benefits",
      title: "We reduce costs and increase quality.",
      text:
        "By cooperating with the SauberEko brand of professionalism and expertise, you obtain a certificate that confirms your professionalism and gains respect and appreciation among major European investors. This certificate guarantees you higher credibility among subcontractors and provides you with a competitive advantage.",
      stats: [
        { value: "100%", label: "Individual assessment" },
        { value: "EU", label: "European recognition" },
        { value: "Elite", label: "In your field" },
      ],
    },
    contact: {
      overline: "Contact",
      title: "Begin your journey to excellence",
      text: "Write to us and we will help you obtain the prestigious SauberEko® certificate.",
      name: "Full name",
      email: "Email",
      company: "Company (optional)",
      message: "Your message",
      submit: "Send message",
      sending: "Sending...",
      success: "Thank you! Your message has been sent.",
      error: "Something went wrong. Please try again.",
      consent: "I agree to the processing of my personal data",
      consentLink: "Privacy Policy",
      consentRequired: "Consent to the processing of personal data is required to submit.",
      phone: "Call us",
      mail: "Email us",
      visit: "Find us",
    },
    footer: {
      tagline: "The Brand of True Professionals.",
      rights: "All rights reserved.",
      privacy: "Privacy Policy",
    },
    pages: {
      common: { partnership: "Inquire about partnership", consultation: "Book a consultation", contactCta: "Contact us" },
      services: {
        overline: "Services",
        title: "Professional brand",
        subtitle: "Our main services offered",
        items: [
          {
            title: "Certification of Companies and Individuals",
            text: "Are your methodologies truly unique? Is your approach professional? Gain a competitive advantage with the Sa.Eko Certificate. Demonstrate your excellence through our assessment processes and compliance with the Sa.Eko Codex.",
          },
        ],
        whyTitle: "Why choose us?",
        why: [
          { title: "Everyone is unique to us", text: "We and our collaborators strictly adhere to the Sa.Eko standards, which guarantee you quality and professionalism in all aspects." },
          { title: "Excellent services", text: "Our services are a guarantee of quality and strict adherence to the Sa.Eko Codex, protected by the SauberEko trademark. We do not promise quality — we guarantee it." },
          { title: "Free consultation", text: "Do not hesitate to contact us; together we will find a solution and an agreement for cooperation. We guarantee a professional approach to your situation." },
        ],
      },
      about: {
        overline: "About Us",
        title: "Welcome to SauberEko®",
        subtitle: "“The Brand of True Professionals.”",
        intro:
          "The proven knowledge and experience of our brand of professionalism and expertise guarantee certified professionals. The brand is characterized by strict internal standards and continuous improvement of professional practice, providing absolute credibility and uniqueness in the field.",
        missionTitle: "Our Mission: Building an Ecosystem of Genuine Professionals",
        missionText:
          "In today's fast-paced world, where the focus often shifts toward quantity and speed, the most essential elements are frequently lost — true expertise and honest craftsmanship. Our group was established as a direct response to a market saturated with entities that prioritize short-term profit over sustainable quality. With more than 20 years of experience in technically demanding industries, we have committed ourselves to creating a platform that stands as a synonym for professionalism across every sector.",
        values: [
          { title: "Absolute Expertise", text: "Proven by years of hands-on experience and real-world results." },
          { title: "Honesty and Transparency", text: "A fair approach is the foundation of every agreement we make." },
          { title: "Humanity and Humility", text: "Respect for the craft, for our partners, and for the responsibility we carry." },
        ],
        brandTitle: "A Brand Defined by Results, Not by Price",
        brandText:
          "We often state that our brand cannot 'simply' be bought. This does not mean we are closed to cooperation — quite the opposite. However, it means that any association with our name is contingent upon meeting strictly defined criteria. Our name and reputation are the result of two decades of hard work.",
        criteriaTitle: "Our trust and collaboration are earned only when you demonstrate:",
        criteria: [
          "Genuine professionalism in your respective field.",
          "An ethical approach toward business and clients.",
          "A clear vision to be among the elite who refuse to compromise on quality, even under pressure.",
        ],
        guaranteesTitle: "Guarantees and Certification",
        guarantees: [
          { title: "Guarantees and Certification", text: "The SauberEko brand of professionalism and expertise specializes in industry-specific verification of the experience and level of expertise of companies and individuals." },
          { title: "International Certifications", text: "We cooperate with domestic and foreign partners to ensure and guarantee the highest quality of the services we provide." },
          { title: "Professional Certifications", text: "SauberEko professionals hold various certificates and have many years of experience and expertise at the highest level." },
          { title: "Innovative Guarantees", text: "Our brand of professionalism and expertise offers innovative guarantees that will give you certainty and peace of mind in your business activities." },
        ],
      },
      certification: {
        overline: "Certification",
        title: "Stand out from the crowd and show everyone that you are a professional!",
        individualsTitle: "Certification of Individuals — Sa.Eko.Prs-2026-0001",
        individualsText: "We provide certification that demonstrates your expertise and practice, improves processes, and increases customer trust.",
        companiesTitle: "Certification of Companies and Firms — Sa.Eko.Fa-2026-0001",
        companiesText: "We certify companies according to our internal standards, increasing the awareness and uniqueness of the company. We deliver excellence and exclusivity to companies.",
        individualsProcTitle: "Procedure for Individuals",
        individualSteps: [
          { title: "Needs analysis", text: "We identify and analyze requirements and goals." },
          { title: "Registration", text: "Filling out the contact form." },
          { title: "Exam planning", text: "We will create a schedule for the proficiency exam." },
          { title: "Exam implementation", text: "We conduct a professional exam, verify your practice and record the results." },
          { title: "Issuance of certificate", text: "After passing the exam we issue a certificate by level: Beginner, Experienced, Professional." },
        ],
        companiesProcTitle: "Procedure for Companies",
        companySteps: [
          { title: "Registration and communication", text: "Define your focus and goals in detail." },
          { title: "Assessment planning", text: "We determine the procedure and prepare a team of professionals for your focus." },
          { title: "Assessment", text: "Our independent team conducts a thorough and precise assessment of expertise." },
          { title: "Final report", text: "We prepare a final report on professionalism and expertise." },
          { title: "Certification and audit", text: "We perform certification with an annual audit. You receive a unique Sa.Eko.Fa-2026 certificate and exclusivity." },
        ],
      },
      code: {
        overline: "Sa.Eko Codex",
        title: "Code of Professional Integrity and Quality",
        intro:
          "At SauberEko, we believe that top-tier results are the outcome of combining technical precision with strong moral principles. Our Sa.Eko Standards define the way we approach projects, partners, and our own professional expertise.",
        pillarsTitle: "10 Pillars of Our Expertise and Responsibility",
        pillars: [
          { title: "Culture of Respect and Humility", text: "Humanity is the foundation of SauberEko. We approach every project, colleague, and partner with humility and mutual respect." },
          { title: "Radical Transparency of Competencies", text: "We guarantee our investors 100% truthfulness regarding our skills and experience. We do not overstate our capacities." },
          { title: "Sa.Eko Peer Support", text: "We foster an environment of strong synergy. The willingness to collaborate and support the team is a fundamental requirement." },
          { title: "Development, Innovation & Ecology Protection", text: "We view expertise as an ongoing process. We actively adopt new technologies and stay gentle to nature — favouring eco-friendly materials and procedures that save water and energy. This also meets the strict hygiene and safety demands of the food industry, where cleanliness and health protection allow no compromise." },
          { title: "Active Partnership in Planning", text: "We are not just a contractor; we are a partner. We actively participate in project design from the very beginning." },
          { title: "Transparency of Technical Equipment", text: "We provide accurate information about our machinery, deployed in flawless condition and meeting all requirements." },
          { title: "Absolute Technical Discipline", text: "Safety is our priority. We strictly adhere to service intervals and certification deadlines for all tools." },
          { title: "Personal Guarantee for Workmanship", text: "We stand behind the work of SauberEko with our reputation. Every task is performed responsibly, with a full guarantee." },
          { title: "Immediate Rectification and Defect Minimization", text: "We are proactive. Any deficiencies are addressed immediately to minimize the impact on the investor." },
          { title: "Integrity of the Entire Chain", text: "We extend the Sa.Eko Standards to our suppliers. We guarantee that every link shares our values and quality requirements." },
        ],
        declarationTitle: "Applicant Declaration",
        declaration: "By my signature, I confirm that I have read the Code of Professional Integrity and Quality. I understand that its violation is grounds for withdrawal of the Sa.Eko certificate.",
      },
    },
  },

  de: {
    nav: {
      services: "Leistungen",
      about: "Über uns",
      standard: "Sa.Eko Standard",
      certification: "Zertifizierung",
      contact: "Kontakt",
      cta: "Zertifizieren",
      login: "Anmelden / Registrieren",
    },
    hero: {
      badge: "Die Marke echter Profis",
      title: "SauberEko",
      subtitle: "Wo Expertise zum Standard wird.",
      paragraph:
        "SauberEko® steht nicht nur für technische Standards. Es ist ein Bekenntnis zu Professionalität, Ethik und höchster Qualität in jeder Branche. Mit unserem Zertifikat bestätigen wir, dass der Inhaber zur Elite seines Fachgebiets gehört.",
      ctaPrimary: "Erkennen Sie einen Profi, solange noch Zeit ist",
      heroQuote: "„Ein guter Mensch zu werden können wir dir nicht beibringen — ein Profi zu werden schon.\nUnd jeder wahre Profi ist auch ein guter Mensch.“",
      heroQuoteAuthor: "Gründer der Marke",
      ctaSecondary: "Den Standard entdecken",
      scroll: "Mehr entdecken",
    },
    values: {
      overline: "Unsere Säulen",
      title: "Drei Prinzipien, eine renommierte Marke",
      items: [
        { title: "Professionalität", text: "Jahrelange bewährte Expertise, bestätigt durch unabhängige Bewertung." },
        { title: "Ethik", text: "Ein Bekenntnis zu Ehrlichkeit, Transparenz und Verantwortung." },
        { title: "Höchste Qualität", text: "Ein Standard, der von Investoren in ganz Europa respektiert wird." },
      ],
    },
    certification: {
      overline: "Zertifizierung",
      title: "Ein Siegel des Vertrauens unter der europäischen Marke",
      text:
        "Von uns zertifizierte Experten und Unternehmen garantieren Professionalität und jahrelange Expertise unter der renommierten europäischen Marke SauberEko®.",
      bullets: [
        "Unabhängige und objektive Bewertung",
        "Europäische Anerkennung und Glaubwürdigkeit",
        "Dauerhafter Wert für Ihre Marke",
      ],
    },
    standard: {
      overline: "Sa.Eko Standard",
      title: "Einzigartiger Ansatz zur Zertifizierung",
      text:
        "Unsere Zertifizierung basiert auf einer individuellen Bewertung mit unseren internen Methoden und ist auf Ihre Bedürfnisse zugeschnitten, um berufliche Exzellenz zu erreichen.",
      steps: [
        { no: "01", title: "Bewertung", text: "Eine gründliche Analyse Ihrer Expertise und Erfahrung." },
        { no: "02", title: "Methodik", text: "Bewertung anhand des internen Sa.Eko-Standards." },
        { no: "03", title: "Zertifikat", text: "Verleihung der renommierten europäischen Marke SauberEko®." },
      ],
    },
    benefits: {
      overline: "Vorteile",
      title: "Wir senken Kosten und steigern die Qualität.",
      text:
        "Durch die Zusammenarbeit mit der SauberEko-Marke für Professionalität und Fachkompetenz erhalten Sie ein Zertifikat, das Ihre Professionalität bestätigt und Respekt und Anerkennung bei bedeutenden europäischen Investoren gewinnt. Dieses Zertifikat garantiert Ihnen höhere Glaubwürdigkeit bei Subunternehmern und verschafft Ihnen einen Wettbewerbsvorteil.",
      stats: [
        { value: "100%", label: "Individuelle Bewertung" },
        { value: "EU", label: "Europäische Anerkennung" },
        { value: "Elite", label: "In Ihrem Fachgebiet" },
      ],
    },
    contact: {
      overline: "Kontakt",
      title: "Beginnen Sie Ihren Weg zur Exzellenz",
      text: "Schreiben Sie uns und wir helfen Ihnen, das renommierte SauberEko®-Zertifikat zu erhalten.",
      name: "Vollständiger Name",
      email: "E-Mail",
      company: "Unternehmen (optional)",
      message: "Ihre Nachricht",
      submit: "Nachricht senden",
      sending: "Senden...",
      success: "Vielen Dank! Ihre Nachricht wurde gesendet.",
      error: "Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.",
      consent: "Ich stimme der Verarbeitung meiner personenbezogenen Daten zu",
      consentLink: "Datenschutzrichtlinie",
      consentRequired: "Für die Übermittlung ist die Einwilligung zur Verarbeitung personenbezogener Daten erforderlich.",
      phone: "Rufen Sie uns an",
      mail: "Schreiben Sie uns",
      visit: "Finden Sie uns",
    },
    footer: {
      tagline: "Die Marke echter Profis.",
      rights: "Alle Rechte vorbehalten.",
      privacy: "Datenschutzrichtlinie",
    },
    pages: {
      common: { partnership: "Partnerschaft anfragen", consultation: "Beratung buchen", contactCta: "Kontaktieren Sie uns" },
      services: {
        overline: "Leistungen",
        title: "Professionelle Marke",
        subtitle: "Unsere wichtigsten Leistungen",
        items: [
          {
            title: "Zertifizierung von Unternehmen und Einzelpersonen",
            text: "Sind Ihre Methoden wirklich einzigartig? Ist Ihr Ansatz professionell? Verschaffen Sie sich einen Wettbewerbsvorteil mit dem Sa.Eko-Zertifikat. Beweisen Sie Ihre Exzellenz durch unsere Bewertungsprozesse und die Einhaltung des Sa.Eko-Kodex.",
          },
        ],
        whyTitle: "Warum uns wählen?",
        why: [
          { title: "Jeder ist für uns einzigartig", text: "Wir und unsere Partner halten uns strikt an die Sa.Eko-Standards, die Ihnen Qualität und Professionalität in allen Aspekten garantieren." },
          { title: "Hervorragende Leistungen", text: "Unsere Leistungen sind eine Garantie für Qualität und die strikte Einhaltung des Sa.Eko-Kodex, geschützt durch die Marke SauberEko. Wir versprechen Qualität nicht — wir garantieren sie." },
          { title: "Kostenlose Beratung", text: "Zögern Sie nicht, uns zu kontaktieren; gemeinsam finden wir eine Lösung und eine Vereinbarung zur Zusammenarbeit. Wir garantieren einen professionellen Ansatz." },
        ],
      },
      about: {
        overline: "Über uns",
        title: "Willkommen bei SauberEko®",
        subtitle: "„Die Marke echter Profis.“",
        intro:
          "Das bewährte Wissen und die Erfahrung unserer Marke für Professionalität und Fachkompetenz garantieren zertifizierte Fachleute. Die Marke zeichnet sich durch strenge interne Standards und kontinuierliche Verbesserung der beruflichen Praxis aus und bietet absolute Glaubwürdigkeit und Einzigartigkeit im Fachgebiet.",
        missionTitle: "Unsere Mission: Aufbau eines Ökosystems echter Fachleute",
        missionText:
          "In der heutigen schnelllebigen Welt, in der der Fokus oft auf Quantität und Geschwindigkeit liegt, gehen die wesentlichsten Elemente verloren — echte Expertise und ehrliche Handwerkskunst. Unsere Gruppe entstand als direkte Antwort auf einen Markt voller Akteure, die kurzfristigen Profit über nachhaltige Qualität stellen. Mit mehr als 20 Jahren Erfahrung in technisch anspruchsvollen Branchen haben wir uns verpflichtet, eine Plattform zu schaffen, die in jedem Sektor für Professionalität steht.",
        values: [
          { title: "Absolute Expertise", text: "Bewiesen durch jahrelange praktische Erfahrung und reale Ergebnisse." },
          { title: "Ehrlichkeit und Transparenz", text: "Ein fairer Ansatz ist die Grundlage jeder Vereinbarung, die wir treffen." },
          { title: "Menschlichkeit und Demut", text: "Respekt für das Handwerk, für unsere Partner und für die Verantwortung, die wir tragen." },
        ],
        brandTitle: "Eine Marke, die durch Ergebnisse definiert wird, nicht durch den Preis",
        brandText:
          "Wir sagen oft, dass unsere Marke nicht „einfach“ gekauft werden kann. Das bedeutet nicht, dass wir einer Zusammenarbeit verschlossen sind — ganz im Gegenteil. Es bedeutet jedoch, dass jede Verbindung mit unserem Namen an die Erfüllung streng definierter Kriterien geknüpft ist. Unser Name und Ruf sind das Ergebnis von zwei Jahrzehnten harter Arbeit.",
        criteriaTitle: "Unser Vertrauen und unsere Zusammenarbeit verdienen Sie, wenn Sie nachweisen:",
        criteria: [
          "Echte Professionalität in Ihrem Fachgebiet.",
          "Einen ethischen Ansatz gegenüber Geschäft und Kunden.",
          "Eine klare Vision, zur Elite zu gehören, die auch unter Druck keine Kompromisse bei der Qualität macht.",
        ],
        guaranteesTitle: "Garantien und Zertifizierung",
        guarantees: [
          { title: "Garantien und Zertifizierung", text: "Die SauberEko-Marke für Professionalität und Fachkompetenz ist auf die branchenspezifische Überprüfung der Erfahrung und des Fachwissens von Unternehmen und Einzelpersonen spezialisiert." },
          { title: "Internationale Zertifizierungen", text: "Wir arbeiten mit in- und ausländischen Partnern zusammen, um die höchste Qualität unserer Leistungen zu gewährleisten." },
          { title: "Berufliche Zertifizierungen", text: "SauberEko-Fachleute besitzen verschiedene Zertifikate und verfügen über langjährige Erfahrung auf höchstem Niveau." },
          { title: "Innovative Garantien", text: "Unsere Marke für Professionalität und Fachkompetenz bietet innovative Garantien, die Ihnen Sicherheit und Ruhe bei Ihren geschäftlichen Aktivitäten geben." },
        ],
      },
      certification: {
        overline: "Zertifizierung",
        title: "Heben Sie sich von der Masse ab und zeigen Sie allen, dass Sie ein Profi sind!",
        individualsTitle: "Zertifizierung von Einzelpersonen — Sa.Eko.Prs-2026-0001",
        individualsText: "Wir bieten eine Zertifizierung, die Ihre Expertise und Praxis nachweist, Prozesse verbessert und das Kundenvertrauen stärkt.",
        companiesTitle: "Zertifizierung von Unternehmen und Firmen — Sa.Eko.Fa-2026-0001",
        companiesText: "Wir zertifizieren Unternehmen nach unseren internen Standards und steigern so das Bewusstsein und die Einzigartigkeit des Unternehmens. Wir liefern Exzellenz und Exklusivität.",
        individualsProcTitle: "Ablauf für Einzelpersonen",
        individualSteps: [
          { title: "Bedarfsanalyse", text: "Wir identifizieren und analysieren Anforderungen und Ziele." },
          { title: "Registrierung", text: "Ausfüllen des Kontaktformulars." },
          { title: "Prüfungsplanung", text: "Wir erstellen einen Zeitplan für die Fachprüfung." },
          { title: "Prüfungsdurchführung", text: "Wir führen eine Fachprüfung durch, verifizieren Ihre Praxis und protokollieren die Ergebnisse." },
          { title: "Ausstellung des Zertifikats", text: "Nach bestandener Prüfung stellen wir ein Zertifikat nach Niveau aus: Anfänger, Erfahren, Profi." },
        ],
        companiesProcTitle: "Ablauf für Unternehmen",
        companySteps: [
          { title: "Registrierung und Kommunikation", text: "Definieren Sie Ihren Fokus und Ihre Ziele im Detail." },
          { title: "Bewertungsplanung", text: "Wir legen das Verfahren fest und stellen ein Team von Fachleuten für Ihren Fokus zusammen." },
          { title: "Bewertung", text: "Unser unabhängiges Team führt eine gründliche und präzise Bewertung der Expertise durch." },
          { title: "Abschlussbericht", text: "Wir erstellen einen Abschlussbericht über Professionalität und Expertise." },
          { title: "Zertifizierung und Audit", text: "Wir führen die Zertifizierung mit jährlichem Audit durch. Sie erhalten ein einzigartiges Sa.Eko.Fa-2026-Zertifikat und Exklusivität." },
        ],
      },
      code: {
        overline: "Sa.Eko Kodex",
        title: "Kodex der beruflichen Integrität und Qualität",
        intro:
          "Bei SauberEko glauben wir, dass Spitzenergebnisse aus der Verbindung technischer Präzision mit starken moralischen Prinzipien entstehen. Unsere Sa.Eko-Standards definieren, wie wir an Projekte, Partner und unsere eigene Fachkompetenz herangehen.",
        pillarsTitle: "10 Säulen unserer Expertise und Verantwortung",
        pillars: [
          { title: "Kultur des Respekts und der Demut", text: "Menschlichkeit ist das Fundament von SauberEko. Wir begegnen jedem Projekt, Kollegen und Partner mit Demut und gegenseitigem Respekt." },
          { title: "Radikale Transparenz der Kompetenzen", text: "Wir garantieren unseren Investoren 100% Wahrhaftigkeit bezüglich unserer Fähigkeiten und Erfahrungen. Wir überbewerten unsere Kapazitäten nicht." },
          { title: "Sa.Eko Kollegiale Unterstützung", text: "Wir fördern ein Umfeld starker Synergie. Die Bereitschaft zur Zusammenarbeit und Teamunterstützung ist eine grundlegende Anforderung." },
          { title: "Entwicklung, Innovation & Umweltschutz", text: "Wir betrachten Expertise als fortlaufenden Prozess. Wir führen aktiv neue Technologien ein und gehen schonend mit der Natur um — wir bevorzugen umweltfreundliche Materialien und Verfahren, die Wasser und Energie sparen. So erfüllen wir auch die strengen Hygiene- und Sicherheitsanforderungen der Lebensmittelindustrie, wo Sauberkeit und Gesundheitsschutz keine Kompromisse kennen." },
          { title: "Aktive Partnerschaft bei der Planung", text: "Wir sind nicht nur Auftragnehmer, sondern Partner. Wir beteiligen uns von Anfang an aktiv am Projektentwurf." },
          { title: "Transparenz der technischen Ausrüstung", text: "Wir liefern genaue Informationen über unsere Maschinen, die in einwandfreiem Zustand sind und alle Anforderungen erfüllen." },
          { title: "Absolute technische Disziplin", text: "Sicherheit hat für uns Priorität. Wir halten Serviceintervalle und Zertifizierungsfristen für alle Werkzeuge strikt ein." },
          { title: "Persönliche Garantie für die Ausführung", text: "Wir stehen mit unserem Ruf hinter der Arbeit von SauberEko. Jede Aufgabe wird verantwortungsvoll und mit voller Garantie ausgeführt." },
          { title: "Sofortige Behebung und Minimierung von Mängeln", text: "Wir sind proaktiv. Etwaige Mängel werden sofort behoben, um die Auswirkungen auf den Investor zu minimieren." },
          { title: "Integrität der gesamten Kette", text: "Wir erweitern die Sa.Eko-Standards auch auf unsere Lieferanten. Wir garantieren, dass jedes Glied unsere Werte teilt." },
        ],
        declarationTitle: "Erklärung des Antragstellers",
        declaration: "Mit meiner Unterschrift bestätige ich, dass ich den Kodex der beruflichen Integrität und Qualität gelesen habe. Mir ist bewusst, dass dessen Verletzung ein Grund für den Entzug des Sa.Eko-Zertifikats ist.",
      },
    },
  },
};

export const CONTACT_INFO = {
  email: "info@saubereko.eu",
  phone: "+421 908 190 189",
  phoneRaw: "+421908190189",
  facebook: "https://facebook.com/profile.php?id=61588219017813",
  address: "SauberEko s.r.o., Ivana Krasku 25/9, 972 71 Nováky, Slovakia",
  mapQuery:
    "https://www.google.com/maps/search/?api=1&query=SauberEko%20s.r.o.%2C%20Ivana%20Krasku%2025%2F9%2C%20972%2071%20Nov%C3%A1ky%2C%20Slovakia",
};

// PL — Polish translation
translations.pl = {
  nav: {
    services: "Usługi",
    about: "O nas",
    standard: "Standard Sa.Eko",
    certification: "Certyfikacja",
    contact: "Kontakt",
    cta: "Uzyskaj certyfikat",
    login: "Zaloguj / Zarejestruj",
  },
  hero: {
    badge: "Marka prawdziwych profesjonalistów",
    title: "SauberEko",
    subtitle: "Gdzie fachowość staje się standardem.",
    paragraph:
      "SauberEko® to nie tylko standardy techniczne. To zobowiązanie do profesjonalizmu, etyki i najwyższej jakości w każdej branży. Naszym certyfikatem potwierdzamy, że jego posiadacz należy do elity w swojej dziedzinie.",
    ctaPrimary: "Rozpoznaj profesjonalistę, póki jest czas",
      heroQuote: "„Nie nauczymy Cię być dobrym człowiekiem — ale profesjonalistą tak.\nA każdy prawdziwy profesjonalista jest też dobrym człowiekiem.“",
      heroQuoteAuthor: "założyciel marki",
    ctaSecondary: "Poznaj standard",
    scroll: "Odkryj więcej",
  },
  values: {
    overline: "Nasze filary",
    title: "Trzy zasady, jedna prestiżowa marka",
    items: [
      { title: "Profesjonalizm", text: "Lata udowodnionej fachowości potwierdzone niezależną oceną." },
      { title: "Etyka", text: "Zobowiązanie do uczciwości, transparentności i odpowiedzialności." },
      { title: "Najwyższa jakość", text: "Standard szanowany przez inwestorów w całej Europie." },
    ],
  },
  certification: {
    overline: "Certyfikacja",
    title: "Pieczęć zaufania pod europejskim znakiem towarowym",
    text:
      "Eksperci i firmy certyfikowani przez nas gwarantują profesjonalizm i wieloletnią fachowość pod prestiżowym europejskim znakiem towarowym SauberEko®.",
    bullets: [
      "Niezależna i obiektywna ocena",
      "Europejskie uznanie i wiarygodność",
      "Trwała wartość Twojej marki",
    ],
  },
  standard: {
    overline: "Standard Sa.Eko",
    title: "Unikalne podejście do certyfikacji",
    text:
      "Nasza certyfikacja opiera się na indywidualnej ocenie przy użyciu naszych wewnętrznych metod i jest dostosowana do Twoich potrzeb, aby osiągnąć doskonałość zawodową.",
    steps: [
      { no: "01", title: "Ocena", text: "Dokładna analiza Twojej fachowości i doświadczenia." },
      { no: "02", title: "Metodyka", text: "Ocena według wewnętrznego standardu Sa.Eko." },
      { no: "03", title: "Certyfikat", text: "Przyznanie prestiżowego europejskiego znaku SauberEko®." },
    ],
  },
  benefits: {
    overline: "Korzyści",
    title: "Obniżamy koszty i podnosimy jakość.",
    text:
      "Współpracując z marką profesjonalizmu i fachowości SauberEko, uzyskujesz certyfikat, który potwierdza Twój profesjonalizm oraz zyskuje szacunek i uznanie wśród znaczących europejskich inwestorów. Certyfikat ten gwarantuje Ci wyższą wiarygodność wśród podwykonawców i zapewnia przewagę konkurencyjną.",
    stats: [
      { value: "100%", label: "Indywidualna ocena" },
      { value: "UE", label: "Europejskie uznanie" },
      { value: "Elita", label: "W Twojej dziedzinie" },
    ],
  },
  contact: {
    overline: "Kontakt",
    title: "Rozpocznij swoją drogę do doskonałości",
    text: "Napisz do nas, a pomożemy Ci uzyskać prestiżowy certyfikat SauberEko®.",
    name: "Imię i nazwisko",
    email: "E-mail",
    company: "Firma (opcjonalnie)",
    message: "Twoja wiadomość",
    submit: "Wyślij wiadomość",
    sending: "Wysyłam...",
    success: "Dziękujemy! Twoja wiadomość została wysłana.",
    error: "Coś poszło nie tak. Spróbuj ponownie.",
    consent: "Wyrażam zgodę na przetwarzanie danych osobowych",
    consentLink: "Zasady ochrony danych osobowych",
    consentRequired: "Do wysłania wymagana jest zgoda na przetwarzanie danych osobowych.",
    phone: "Zadzwoń do nas",
    mail: "Napisz do nas",
    visit: "Znajdź nas",
  },
  footer: {
    tagline: "Marka prawdziwych profesjonalistów.",
    rights: "Wszelkie prawa zastrzeżone.",
    privacy: "Zasady ochrony danych osobowych",
  },
  pages: {
    common: { partnership: "Zapytaj o współpracę", consultation: "Zarezerwuj konsultację", contactCta: "Skontaktuj się z nami" },
    services: {
      overline: "Usługi",
      title: "Profesjonalna marka",
      subtitle: "Nasze główne oferowane usługi",
      items: [
        {
          title: "Certyfikacja firm i osób fizycznych",
          text: "Czy Twoje metodyki są naprawdę unikalne? Czy Twoje podejście jest profesjonalne? Zyskaj przewagę konkurencyjną dzięki certyfikatowi Sa.Eko. Wykaż swoją doskonałość poprzez nasze procesy oceny i zgodność z Kodeksem Sa.Eko.",
        },
      ],
      whyTitle: "Dlaczego warto wybrać właśnie nas?",
      why: [
        { title: "Każdy jest dla nas wyjątkowy", text: "My i nasi współpracownicy ściśle przestrzegamy standardów Sa.Eko, które gwarantują Ci jakość i profesjonalizm we wszystkich aspektach." },
        { title: "Doskonałe usługi", text: "Nasze usługi są gwarancją jakości i ścisłego przestrzegania Kodeksu Sa.Eko, chronionego znakiem towarowym SauberEko. Nie obiecujemy jakości — gwarantujemy ją." },
        { title: "Bezpłatna konsultacja", text: "Nie wahaj się z nami skontaktować; wspólnie z pewnością znajdziemy rozwiązanie i porozumienie o współpracy. Gwarantujemy profesjonalne podejście." },
      ],
    },
    about: {
      overline: "O nas",
      title: "Witamy w SauberEko®",
      subtitle: "„Marka prawdziwych profesjonalistów.”",
      intro:
        "Udowodniona wiedza i doświadczenie naszej marki profesjonalizmu i fachowości gwarantują certyfikowanych profesjonalistów. Marka wyróżnia się rygorystycznymi standardami wewnętrznymi i nieustannym doskonaleniem praktyki zawodowej, zapewniając absolutną wiarygodność i wyjątkowość w branży.",
      missionTitle: "Nasza misja: budowanie ekosystemu prawdziwych profesjonalistów",
      missionText:
        "W dzisiejszym szybkim świecie, gdzie nacisk często kładziony jest na ilość i szybkość, gubi się to, co najważniejsze — prawdziwa fachowość i rzetelna praca. Nasza grupa powstała jako odpowiedź na rynek przesycony podmiotami, które przedkładają krótkoterminowy zysk nad trwałą jakość. Z ponad 20-letnim doświadczeniem w technicznie wymagających branżach zobowiązaliśmy się stworzyć platformę, która jest synonimem profesjonalizmu w każdym sektorze.",
      values: [
        { title: "Absolutna fachowość", text: "Udowodniona latami praktyki i realnymi wynikami." },
        { title: "Uczciwość i transparentność", text: "Rzetelne podejście jest podstawą każdej naszej umowy." },
        { title: "Człowieczeństwo i pokora", text: "Szacunek dla rzemiosła, partnerów i odpowiedzialności, którą ponosimy." },
      ],
      brandTitle: "Marka definiowana wynikami, a nie ceną",
      brandText:
        "Często mówimy, że naszej marki nie można „po prostu” kupić. Nie oznacza to, że jesteśmy zamknięci na współpracę — wręcz przeciwnie. Oznacza to jednak, że jakiekolwiek powiązanie z naszą nazwą jest uwarunkowane spełnieniem ściśle określonych kryteriów. Nasza nazwa i reputacja są wynikiem dwóch dekad ciężkiej pracy.",
      criteriaTitle: "Nasze zaufanie i współpracę zdobędziesz, gdy wykażesz:",
      criteria: [
        "Prawdziwy profesjonalizm w swojej dziedzinie.",
        "Etyczne podejście do biznesu i klientów.",
        "Jasną wizję bycia wśród elity, która nie idzie na kompromisy w kwestii jakości, nawet pod presją.",
      ],
      guaranteesTitle: "Gwarancje i certyfikacja",
      guarantees: [
        { title: "Gwarancje i certyfikacja", text: "Marka profesjonalizmu i fachowości SauberEko specjalizuje się w weryfikacji doświadczenia i poziomu fachowości firm oraz osób w danej branży." },
        { title: "Międzynarodowe certyfikacje", text: "Współpracujemy z partnerami krajowymi i zagranicznymi, aby zapewnić najwyższą jakość świadczonych usług." },
        { title: "Certyfikacje zawodowe", text: "Profesjonaliści SauberEko posiadają różne certyfikaty oraz wieloletnie doświadczenie na najwyższym poziomie." },
        { title: "Innowacyjne gwarancje", text: "Nasza marka profesjonalizmu i fachowości oferuje innowacyjne gwarancje, które dadzą Ci pewność i spokój w działalności biznesowej." },
      ],
    },
    certification: {
      overline: "Certyfikacja",
      title: "Wyróżnij się z tłumu i pokaż wszystkim, że jesteś profesjonalistą!",
      individualsTitle: "Certyfikacja osób fizycznych — Sa.Eko.Prs-2026-0001",
      individualsText: "Zapewniamy certyfikację, która potwierdza Twoją fachowość i praktykę, usprawnia procesy i zwiększa zaufanie klientów.",
      companiesTitle: "Certyfikacja firm i przedsiębiorstw — Sa.Eko.Fa-2026-0001",
      companiesText: "Certyfikujemy firmy zgodnie z naszymi wewnętrznymi standardami, zwiększając rozpoznawalność i wyjątkowość firmy. Firmom zapewniamy doskonałość i ekskluzywność.",
      individualsProcTitle: "Procedura dla osób fizycznych",
      individualSteps: [
        { title: "Analiza potrzeb", text: "Identyfikujemy i analizujemy wymagania oraz cele." },
        { title: "Rejestracja", text: "Wypełnienie formularza kontaktowego." },
        { title: "Planowanie egzaminu", text: "Tworzymy harmonogram egzaminu fachowego." },
        { title: "Przeprowadzenie egzaminu", text: "Przeprowadzamy egzamin fachowy, weryfikujemy Twoją praktykę i zapisujemy wyniki." },
        { title: "Wydanie certyfikatu", text: "Po pomyślnym zdaniu wydajemy certyfikat według poziomu: Początkujący, Doświadczony, Profesjonalista." },
      ],
      companiesProcTitle: "Procedura dla firm",
      companySteps: [
        { title: "Rejestracja i komunikacja", text: "Szczegółowo określ swoją specjalizację i cele." },
        { title: "Planowanie oceny", text: "Ustalamy procedurę i przygotowujemy zespół profesjonalistów zgodnie z Twoją specjalizacją." },
        { title: "Ocena", text: "Nasz niezależny zespół przeprowadza dokładną i precyzyjną ocenę fachowości." },
        { title: "Raport końcowy", text: "Przygotowujemy raport końcowy dotyczący profesjonalizmu i fachowości." },
        { title: "Certyfikacja i audyt", text: "Przeprowadzamy certyfikację z corocznym audytem. Otrzymujesz unikalny certyfikat Sa.Eko.Fa-2026 i ekskluzywność." },
      ],
    },
    code: {
      overline: "Kodeks Sa.Eko",
      title: "Kodeks integralności zawodowej i jakości",
      intro:
        "W SauberEko wierzymy, że najlepsze wyniki powstają z połączenia precyzji technicznej z silnymi zasadami moralnymi. Nasze standardy Sa.Eko definiują sposób, w jaki podchodzimy do projektów, partnerów i własnej fachowości.",
      pillarsTitle: "10 filarów naszej fachowości i odpowiedzialności",
      pillars: [
        { title: "Kultura szacunku i pokory", text: "Człowieczeństwo jest fundamentem SauberEko. Do każdego projektu, współpracownika i partnera podchodzimy z pokorą i wzajemnym szacunkiem." },
        { title: "Radykalna transparentność kompetencji", text: "Gwarantujemy inwestorom 100% prawdomówności co do naszych umiejętności i doświadczenia. Nie zawyżamy swoich możliwości." },
        { title: "Wzajemne wsparcie Sa.Eko", text: "Budujemy środowisko silnej synergii. Gotowość do współpracy i wspierania zespołu jest podstawowym wymogiem." },
        { title: "Rozwój, innowacje i ochrona ekologii", text: "Fachowość postrzegamy jako proces ciągły. Aktywnie wdrażamy nowe technologie i jesteśmy przyjaźni dla przyrody — stawiamy na ekologiczne materiały i procedury oszczędzające wodę i energię. Dzięki temu spełniamy także rygorystyczne wymogi higieniczne i bezpieczeństwa przemysłu spożywczego, gdzie czystość i ochrona zdrowia nie znają kompromisów." },
        { title: "Aktywne partnerstwo w planowaniu", text: "Nie jesteśmy tylko dostawcą, jesteśmy partnerem. Aktywnie angażujemy się w projektowanie od samego początku." },
        { title: "Transparentność wyposażenia technicznego", text: "Dostarczamy dokładne informacje o naszej technice w nienagannym stanie, spełniającej wszystkie wymagania." },
        { title: "Absolutna dyscyplina techniczna", text: "Bezpieczeństwo to priorytet. Ściśle przestrzegamy interwałów serwisowych i terminów certyfikacyjnych." },
        { title: "Osobista gwarancja za wykonanie", text: "Za pracę SauberEko ręczymy swoją reputacją. Każde zadanie jest wykonywane odpowiedzialnie, z pełną gwarancją." },
        { title: "Natychmiastowa naprawa i minimalizacja błędów", text: "Jesteśmy proaktywni. Wszelkie niedociągnięcia rozwiązujemy natychmiast, aby zminimalizować wpływ na inwestora." },
        { title: "Integralność całego łańcucha", text: "Standardy Sa.Eko rozszerzamy także na naszych dostawców. Gwarantujemy, że każde ogniwo podziela nasze wartości." },
      ],
      declarationTitle: "Oświadczenie wnioskodawcy",
      declaration: "Składając podpis potwierdzam, że zapoznałem się z Kodeksem integralności zawodowej i jakości. Przyjmuję do wiadomości, że jego naruszenie jest podstawą do odebrania certyfikatu Sa.Eko.",
    },
  },
};


// FR — French translation
translations.fr = {
  nav: {
    services: "Services",
    about: "À propos",
    standard: "Standard Sa.Eko",
    certification: "Certification",
    contact: "Contact",
    cta: "Obtenir le certificat",
    login: "Se connecter / S'inscrire",
  },
  hero: {
    badge: "La marque des vrais professionnels",
    title: "SauberEko",
    subtitle: "Là où l'expertise devient la norme.",
    paragraph:
      "SauberEko® ne se limite pas aux normes techniques. C'est un engagement envers le professionnalisme, l'éthique et la plus haute qualité dans tous les secteurs. Par notre certificat, nous confirmons que son titulaire appartient à l'élite de son domaine.",
    ctaPrimary: "Reconnaissez un professionnel tant qu'il est encore temps",
    heroQuote: "« Nous ne pouvons pas t'apprendre à être quelqu'un de bien — mais à être un professionnel, oui.\nEt tout vrai professionnel est aussi quelqu'un de bien. »",
    heroQuoteAuthor: "fondateur de la marque",
    ctaSecondary: "Découvrir le standard",
    scroll: "Découvrir plus",
  },
  values: {
    overline: "Nos piliers",
    title: "Trois principes, une marque prestigieuse",
    items: [
      { title: "Professionnalisme", text: "Des années d'expertise prouvée et confirmée par une évaluation indépendante." },
      { title: "Éthique", text: "Un engagement envers l'honnêteté, la transparence et la responsabilité." },
      { title: "Qualité supérieure", text: "Un standard respecté par les investisseurs dans toute l'Europe." },
    ],
  },
  certification: {
    overline: "Certification",
    title: "Un sceau de confiance sous la marque européenne",
    text:
      "Les experts et les entreprises que nous certifions garantissent le professionnalisme et des années d'expertise sous la prestigieuse marque européenne SauberEko®.",
    bullets: [
      "Évaluation indépendante et objective",
      "Reconnaissance et crédibilité européennes",
      "Une valeur durable pour votre marque",
    ],
  },
  standard: {
    overline: "Standard Sa.Eko",
    title: "Une approche unique de la certification",
    text:
      "Notre certification repose sur une évaluation individuelle à l'aide de nos méthodes internes et est adaptée à vos besoins pour atteindre l'excellence professionnelle.",
    steps: [
      { no: "01", title: "Évaluation", text: "Une analyse approfondie de votre expertise et de votre expérience." },
      { no: "02", title: "Méthodologie", text: "Évaluation selon le standard interne Sa.Eko." },
      { no: "03", title: "Certificat", text: "Attribution de la prestigieuse marque européenne SauberEko®." },
    ],
  },
  benefits: {
    overline: "Avantages",
    title: "Nous réduisons les coûts et augmentons la qualité.",
    text:
      "En coopérant avec la marque de professionnalisme et d'expertise SauberEko, vous obtenez un certificat qui confirme votre professionnalisme et gagne le respect et la reconnaissance des grands investisseurs européens. Ce certificat vous garantit une plus grande crédibilité auprès des sous-traitants et vous offre un avantage concurrentiel.",
    stats: [
      { value: "100 %", label: "Évaluation individuelle" },
      { value: "UE", label: "Reconnaissance européenne" },
      { value: "Élite", label: "Dans votre domaine" },
    ],
  },
  contact: {
    overline: "Contact",
    title: "Commencez votre chemin vers l'excellence",
    text: "Écrivez-nous et nous vous aiderons à obtenir le prestigieux certificat SauberEko®.",
    name: "Nom et prénom",
    email: "E-mail",
    company: "Société (facultatif)",
    message: "Votre message",
    submit: "Envoyer le message",
    sending: "Envoi en cours...",
    success: "Merci ! Votre message a été envoyé.",
    error: "Une erreur s'est produite. Veuillez réessayer.",
    consent: "J'accepte le traitement de mes données personnelles",
    consentLink: "Politique de confidentialité",
    consentRequired: "Le consentement au traitement des données personnelles est requis pour l'envoi.",
    phone: "Appelez-nous",
    mail: "Écrivez-nous",
    visit: "Trouvez-nous",
  },
  footer: {
    tagline: "La marque des vrais professionnels.",
    rights: "Tous droits réservés.",
    privacy: "Politique de confidentialité",
  },
  pages: {
    common: { partnership: "Demander un partenariat", consultation: "Réserver une consultation", contactCta: "Contactez-nous" },
    services: {
      overline: "Services",
      title: "Marque professionnelle",
      subtitle: "Nos principaux services proposés",
      items: [
        {
          title: "Certification des entreprises et des particuliers",
          text: "Vos méthodologies sont-elles vraiment uniques ? Votre approche est-elle professionnelle ? Prenez l'avantage concurrentiel avec le certificat Sa.Eko. Démontrez votre excellence à travers nos processus d'évaluation et le respect du Code Sa.Eko.",
        },
      ],
      whyTitle: "Pourquoi nous choisir ?",
      why: [
        { title: "Chacun est unique pour nous", text: "Nous et nos collaborateurs respectons strictement les standards Sa.Eko, qui vous garantissent qualité et professionnalisme dans tous les aspects." },
        { title: "Des services d'excellence", text: "Nos services sont une garantie de qualité et de respect strict du Code Sa.Eko, protégé par la marque SauberEko. Nous ne promettons pas la qualité — nous la garantissons." },
        { title: "Consultation gratuite", text: "N'hésitez pas à nous contacter ; ensemble, nous trouverons certainement une solution et un accord de coopération. Nous vous garantissons une approche professionnelle." },
      ],
    },
    about: {
      overline: "À propos",
      title: "Bienvenue chez SauberEko®",
      subtitle: "« La marque des vrais professionnels. »",
      intro:
        "Les connaissances et l'expérience éprouvées de notre marque de professionnalisme et d'expertise garantissent des professionnels certifiés. La marque se distingue par des standards internes stricts et une amélioration continue de la pratique professionnelle, offrant une crédibilité et une singularité absolues dans le domaine.",
      missionTitle: "Notre mission : construire un écosystème de véritables professionnels",
      missionText:
        "Dans le monde rapide d'aujourd'hui, où l'accent est souvent mis sur la quantité et la vitesse, on perd l'essentiel — la véritable expertise et le travail honnête. Notre groupe est né en réponse à un marché saturé d'acteurs qui privilégient le profit à court terme au détriment d'une qualité durable. Avec plus de 20 ans d'expérience dans des secteurs techniquement exigeants, nous nous sommes engagés à créer une plateforme synonyme de professionnalisme dans chaque secteur.",
      values: [
        { title: "Expertise absolue", text: "Prouvée par des années de pratique et des résultats concrets." },
        { title: "Honnêteté et transparence", text: "Une approche équitable est le fondement de chacun de nos accords." },
        { title: "Humanité et humilité", text: "Respect du métier, des partenaires et de la responsabilité que nous portons." },
      ],
      brandTitle: "Une marque définie par les résultats, pas par le prix",
      brandText:
        "Nous disons souvent que notre marque ne peut pas « simplement » s'acheter. Cela ne signifie pas que nous sommes fermés à la coopération — bien au contraire. Cela signifie toutefois que toute association à notre nom est conditionnée au respect de critères strictement définis. Notre nom et notre réputation sont le fruit de deux décennies de travail acharné.",
      criteriaTitle: "Vous gagnez notre confiance et notre coopération lorsque vous démontrez :",
      criteria: [
        "Un véritable professionnalisme dans votre domaine.",
        "Une approche éthique envers les affaires et les clients.",
        "Une vision claire d'appartenir à l'élite qui ne fait aucun compromis sur la qualité, même sous pression.",
      ],
      guaranteesTitle: "Garanties et certification",
      guarantees: [
        { title: "Garanties et certification", text: "La marque de professionnalisme et d'expertise SauberEko se spécialise dans la vérification de l'expérience et du niveau d'expertise des entreprises et des particuliers dans leur secteur." },
        { title: "Certifications internationales", text: "Nous coopérons avec des partenaires nationaux et étrangers afin de garantir la plus haute qualité des services fournis." },
        { title: "Certifications professionnelles", text: "Les professionnels SauberEko détiennent divers certificats et possèdent de longues années d'expérience au plus haut niveau." },
        { title: "Garanties innovantes", text: "Notre marque de professionnalisme et d'expertise offre des garanties innovantes qui vous apporteront certitude et sérénité dans vos activités professionnelles." },
      ],
    },
    certification: {
      overline: "Certification",
      title: "Démarquez-vous de la foule et montrez à tous que vous êtes un professionnel !",
      individualsTitle: "Certification des particuliers — Sa.Eko.Prs-2026-0001",
      individualsText: "Nous proposons une certification qui atteste de votre expertise et de votre pratique, améliore les processus et renforce la confiance des clients.",
      companiesTitle: "Certification des entreprises et des sociétés — Sa.Eko.Fa-2026-0001",
      companiesText: "Nous certifions les entreprises selon nos standards internes, augmentant ainsi la notoriété et la singularité de l'entreprise. Nous apportons excellence et exclusivité aux entreprises.",
      individualsProcTitle: "Procédure pour les particuliers",
      individualSteps: [
        { title: "Analyse des besoins", text: "Nous identifions et analysons les exigences et les objectifs." },
        { title: "Inscription", text: "Remplissage du formulaire de contact." },
        { title: "Planification de l'examen", text: "Nous établissons un calendrier pour l'examen de compétence." },
        { title: "Réalisation de l'examen", text: "Nous menons un examen professionnel, vérifions votre pratique et consignons les résultats." },
        { title: "Délivrance du certificat", text: "Après réussite de l'examen, nous délivrons un certificat par niveau : Débutant, Expérimenté, Professionnel." },
      ],
      companiesProcTitle: "Procédure pour les entreprises",
      companySteps: [
        { title: "Inscription et communication", text: "Définissez en détail votre domaine et vos objectifs." },
        { title: "Planification de l'évaluation", text: "Nous déterminons la procédure et préparons une équipe de professionnels selon votre domaine." },
        { title: "Évaluation", text: "Notre équipe indépendante réalise une évaluation approfondie et précise de l'expertise." },
        { title: "Rapport final", text: "Nous préparons un rapport final sur le professionnalisme et l'expertise." },
        { title: "Certification et audit", text: "Nous réalisons la certification avec un audit annuel. Vous recevez un certificat unique Sa.Eko.Fa-2026 et l'exclusivité." },
      ],
    },
    code: {
      overline: "Code Sa.Eko",
      title: "Code d'intégrité professionnelle et de qualité",
      intro:
        "Chez SauberEko, nous croyons que les résultats d'excellence naissent de l'alliance de la précision technique et de principes moraux forts. Nos standards Sa.Eko définissent la manière dont nous abordons les projets, les partenaires et notre propre expertise.",
      pillarsTitle: "10 piliers de notre expertise et de notre responsabilité",
      pillars: [
        { title: "Culture du respect et de l'humilité", text: "L'humanité est le fondement de SauberEko. Nous abordons chaque projet, collègue et partenaire avec humilité et respect mutuel." },
        { title: "Transparence radicale des compétences", text: "Nous garantissons aux investisseurs une véracité à 100 % concernant nos compétences et notre expérience. Nous ne surestimons pas nos capacités." },
        { title: "Soutien mutuel Sa.Eko", text: "Nous cultivons un environnement de forte synergie. La volonté de coopérer et de soutenir l'équipe est une exigence fondamentale." },
        { title: "Développement, innovation et protection de l'environnement", text: "Nous considérons l'expertise comme un processus continu. Nous adoptons activement de nouvelles technologies et respectons la nature — en privilégiant des matériaux et des procédés écologiques qui économisent l'eau et l'énergie. Nous répondons ainsi aussi aux exigences strictes d'hygiène et de sécurité de l'industrie alimentaire, où la propreté et la protection de la santé ne connaissent aucun compromis." },
        { title: "Partenariat actif dans la planification", text: "Nous ne sommes pas qu'un prestataire, nous sommes un partenaire. Nous participons activement à la conception du projet dès le début." },
        { title: "Transparence de l'équipement technique", text: "Nous fournissons des informations précises sur notre matériel, en parfait état et conforme à toutes les exigences." },
        { title: "Discipline technique absolue", text: "La sécurité est notre priorité. Nous respectons strictement les intervalles d'entretien et les échéances de certification." },
        { title: "Garantie personnelle de l'exécution", text: "Nous répondons du travail de SauberEko par notre réputation. Chaque tâche est réalisée de manière responsable, avec une garantie totale." },
        { title: "Correction immédiate et minimisation des défauts", text: "Nous sommes proactifs. Toute déficience est traitée immédiatement afin de minimiser l'impact sur l'investisseur." },
        { title: "Intégrité de toute la chaîne", text: "Nous étendons les standards Sa.Eko à nos fournisseurs. Nous garantissons que chaque maillon partage nos valeurs." },
      ],
      declarationTitle: "Déclaration du candidat",
      declaration: "Par ma signature, je confirme avoir pris connaissance du Code d'intégrité professionnelle et de qualité. Je reconnais que toute violation constitue un motif de retrait du certificat Sa.Eko.",
    },
  },
};
